import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=747f6b95&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f6b95",
  null
  
)

export default component.exports